import { daysInMonth, type Period } from '../dates';
import type { Household } from '../household';
import { toCents, toEuros } from '../money';

/**
 * DE: Budget eines Zeitraums: Monatsbudget anteilig nach Tagen des Startmonats.
 * EN: Budget of a period: the monthly budget prorated by the days of the start month.
 */
export function periodBudget(household: Household, period: Period): number {
  const [year = 0, month = 0] = period.start.split('-').map(Number);
  const share = period.days / daysInMonth(year, month);
  return toEuros(Math.round(toCents(household.monthlyBudget) * share));
}
